__turbopack_context__.v({
  "get_locate_code": "GetLocateCode-module-scss-module__ZiNR1W__get_locate_code",
  "get_locate_code__intro": "GetLocateCode-module-scss-module__ZiNR1W__get_locate_code__intro",
});
